<div class="container" id="page-title">
  <div class="row w-100 justify-content-between">
    <div class="col-md-5 col-12">
      <h1>{{ pageTitle || 'Início' }}</h1>
    </div>
    <div class="col-md-5 col-12">
      <div class="d-flex align-items-center justify-content-end flex-wrap">
        <a class="breadcrumb-item" routerLink="/">Início</a>
        <ng-container *ngFor="let item of menuItems; let i = index">
          <em class="fa fa-chevron-right fa-sm mx-2 text-gray"></em>
          <a class="breadcrumb-item" [routerLink]="item.url"> {{ item.label }} </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>
